module.exports = __webpack_public_path__ + "img/bet-start.4054fe90.png";